import React from "react";
import Button from "./Button";
import "./styles/FilterActions.scss";

interface FilterActionsProps {
  onClear: () => void;
  onApply: () => void;
}

const FilterActions: React.FC<FilterActionsProps> = ({ onClear, onApply }) => {
  return (
    <footer className="filter-actions">
      <div className="filter-actions__buttons">
        <Button
          text="Remove"
          onClick={onClear}
          variant="secondary"
          className="filter-actions__button"
        />
        <Button
          text="Apply"
          onClick={onApply}
          variant="primary"
          className="filter-actions__button"
        />
      </div>
    </footer>
  );
};

export default FilterActions;
